import yachtPaymentsApiService from '@/services/api/YachtPayments'

const CATEGORY_DEPOSIT = 'deposit'
const CATEGORY_FINAL_DEPOSIT = 'final_deposit'
const CATEGORY_BALANCE = 'balance'
const CATEGORY_TRADE_IN = 'trade_in'
const CATEGORY_REFUND = 'refund'
const CATEGORY_PAYMENT_TO_SELLER = 'payment_to_seller'
const CATEGORY_OVERPAYMENT = 'overpayment'
const CATEGORY_FX_DIFFERENCE = 'fx_difference'
const CATEGORY_REALLOCATION = 'reallocation'
const CATEGORY_FINANCED_BY_INSTITUTION = 'financed_by_institution'

const DIRECTION_INFLOW = 'inflow'
const DIRECTION_OUTFLOW = 'outflow'
const DIRECTION_BOTH = 'both'

const DIRECTION_INBOUND = 'inbound'
const DIRECTION_OUTBOUND = 'outbound'

const STATUS_EXPECTED = 'expected'
const STATUS_RECEIVED = 'received'
const STATUS_PAID = 'paid'
const STATUS_OVERDUE = 'overdue'
const STATUS_OVERPAID = 'overpaid'
const STATUS_CANCELED = 'canceled'

const CATEGORY_DATA = {
  [CATEGORY_DEPOSIT]: {
    label: 'Deposit',
    key: CATEGORY_DEPOSIT,
    direction: DIRECTION_INFLOW,
    description_required: false
  },
  [CATEGORY_FINAL_DEPOSIT]: {
    label: 'Final Deposit',
    key: CATEGORY_FINAL_DEPOSIT,
    direction: DIRECTION_INFLOW,
    description_required: false
  },
  [CATEGORY_BALANCE]: {
    label: 'Balance',
    key: CATEGORY_BALANCE,
    direction: DIRECTION_INFLOW,
    description_required: false
  },
  [CATEGORY_TRADE_IN]: {
    label: 'Trade-in',
    key: CATEGORY_TRADE_IN,
    direction: DIRECTION_INFLOW,
    description_required: true
  },
  [CATEGORY_REFUND]: {
    label: 'Refund',
    key: CATEGORY_REFUND,
    direction: DIRECTION_OUTFLOW,
    description_required: true
  },
  [CATEGORY_PAYMENT_TO_SELLER]: {
    label: 'Payment to Seller',
    key: CATEGORY_PAYMENT_TO_SELLER,
    direction: DIRECTION_OUTFLOW,
    description_required: false
  },
  [CATEGORY_OVERPAYMENT]: {
    label: 'Overpayment',
    key: CATEGORY_OVERPAYMENT,
    direction: DIRECTION_OUTFLOW,
    description_required: false
  },
  [CATEGORY_FX_DIFFERENCE]: {
    label: 'FX Difference',
    key: CATEGORY_FX_DIFFERENCE,
    direction: DIRECTION_BOTH,
    description_required: false
  },
  [CATEGORY_REALLOCATION]: {
    label: 'Reallocation',
    key: CATEGORY_REALLOCATION,
    direction: DIRECTION_BOTH,
    description_required: true
  },
  [CATEGORY_FINANCED_BY_INSTITUTION]: {
    label: 'Financed by Institution',
    key: CATEGORY_FINANCED_BY_INSTITUTION,
    direction: DIRECTION_INFLOW,
    description_required: false
  }
}

const STATUS_DATA = {
  [STATUS_EXPECTED]: {
    label: 'Expected',
    color: 'grey darken-1'
  },
  [STATUS_RECEIVED]: {
    label: 'Received',
    color: 'success'
  },
  [STATUS_OVERDUE]: {
    label: 'Overdue',
    color: 'error'
  },
  [STATUS_OVERPAID]: {
    label: 'Overpaid',
    color: 'error'
  },
  [STATUS_PAID]: {
    label: 'Paid',
    color: 'success'
  },
  [STATUS_CANCELED]: {
    label: 'Canceled',
    color: 'grey lighten-2'
  }
}

export default class YachtPayment {
  static api = yachtPaymentsApiService

  static categoryData = CATEGORY_DATA
  static statusData = STATUS_DATA

  static DIRECTION_INFLOW = DIRECTION_INFLOW
  static DIRECTION_OUTFLOW = DIRECTION_OUTFLOW
  static DIRECTION_BOTH = DIRECTION_BOTH
  static DIRECTION_INBOUND = DIRECTION_INBOUND
  static DIRECTION_OUTBOUND = DIRECTION_OUTBOUND
}
